"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingCartItemPriceType = exports.ShoppingCartItemQuantityType = void 0;
var ShoppingCartItemQuantityType;
(function (ShoppingCartItemQuantityType) {
    ShoppingCartItemQuantityType["OutOfStock"] = "OUT_OF_STOCK";
    ShoppingCartItemQuantityType["StockDecreased"] = "STOCK_DECREASED";
})(ShoppingCartItemQuantityType || (exports.ShoppingCartItemQuantityType = ShoppingCartItemQuantityType = {}));
var ShoppingCartItemPriceType;
(function (ShoppingCartItemPriceType) {
    ShoppingCartItemPriceType["PriceIncrease"] = "PRICE_INCREASE";
    ShoppingCartItemPriceType["PriceDecrease"] = "PRICE_DECREASE";
})(ShoppingCartItemPriceType || (exports.ShoppingCartItemPriceType = ShoppingCartItemPriceType = {}));
//# sourceMappingURL=shopping-cart.js.map